
<div id="titleCaja">
  <br>

  <h1 id="title" class="font-weight-light text-center" style="font-size:2rem; color:white;">
    Contáctanos</h1>
</div>
<div class="container">
    
    <div class="row">
        <div class="col">
            <div class="card text-white bg-primary" style="max-width: 18rem; height: 12rem;">
                <div class="card-header text-center" style="font-size:1rem; color: white;">Facebook</div>
                <div class="card-body text-center">
                    <a href="https://m.me/VizsioMX"><i
                        class="fab fa-facebook-messenger fa-lg" style="color:white; font-size: 100px;"></i></a>
                    

                </div>
            </div>
        </div>
        <div class="col">
            <div class="card text-white bg-success" style="max-width: 18rem;  height: 12rem;">
                <div class="card-header text-center" style="font-size:1rem; color: white;">WhatsApp</div>

                <div class="icon-wts-abajo card-body text-center" >
    
                    <img class="icon-wts" src="assets/img/wha.png" width="100" height="100" alt="" id="wtsicon" data-toggle="modal" data-target="#exampleModal">
                    </div>

                <!-- <div class="card-body text-center">
                    <img class="icon-wts" src="assets/img/wha.png" width="100" height="100" alt="" id="wtsicon"
                        data-toggle="modal" data-target="#exampleModal">
                </div> -->
            </div>
        </div>
        <div class="col">
            <div class="card text-white bg-danger" style="max-width: 18rem;  height: 12rem;">
                <div class="card-header text-center" style="font-size:1rem; color: white;">Gmail</div>
                <div class="card-body text-center">

                    <a href="mailto:danie.hdez.var@gmail.com?Subject=Hola%20buen%20dia"><img class="icon-wts"
                            src="assets/img/Gmail.png" width="120" height="95" alt="" >
                    </a>

                </div>
            </div>
        </div>
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Conectate con nosotros</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  
          
                  <form>
                    <div class="form-group">
                      <label for="formGroupExampleInput">Nombre</label>
                      <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Nombre">
                    </div>
                   
                    
                    <div class="form-group">
                      <label for="exampleFormControlTextarea1">Mensaje</label>
                      <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                    </div>
                  </form>
          
          
          
          
          
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
                  <button id="sendbtn" type="button" class="btn btn-success">Enviar</button>
                  
                </div>
              </div>
            </div>
          </div>
        
    </div>
    <br>
    <br>
    <br>
    <br><br> <br>
    <br>
    <br>
    <br>
    
</div>